import React, { useRef, useState } from 'react'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// import required modules
import { Pagination, Navigation } from 'swiper/modules'
import BlurText from './Animations/BlurText'
import AnimatedContent from './Animations/AnimatedContent'
import ShinyText from './Animations/ShinyText'
import GradientText from './Animations/GradientText'
import Waves from './Animations/Waves'
import SplitText from './Animations/SplitText'
import SpotlightCard from './Animations/SpotlightCard'

const DATA = [
    {
        number: 1,
        heading: "Personalized Assistance",
        img: "/images/slider-1.png",
    },
    {
        number: 2,
        heading: "Efficient Token Management",
        img: "/images/slider-2.png",
    },
    {
        number: 3,
        heading: "User-Centric Experience",
        img: "/images/slider-3.png",
    },
    {
        number: 4,
        heading: "Seamless Transaction Execution",
        img: "/images/slider-4.png",
    },
    {
        number: 5,
        heading: "Clear Communication",
        img: "/images/slider-5.png",
    },
    {
        number: 6,
        heading: "Error Handling",
        img: "/images/slider-6.png",
    },

]

export default function Slider() {
    return (
        <div
            className='md:w-[80%] w-[90%] mx-auto md:mt-0 mt-[5vw]'
            id='Features'
        >
            <div className='py-10 relative'>
                <div className='flex flex-col !items-start md:w-[50%] w-full md:absolute static left-[0%] top-[5vw]'>
                    <div className='bg-black md:px-5 py-1 rounded-3xl w-fit md:mb-5 mb-2'>
                        <GradientText
                            colors={["#40ffaa", "#BEFFCD", "#7358F9",]}
                            animationSpeed={3}
                            showBorder={false}
                            className="font-semibold md:text-lg text-sm "
                        >
                            WHY AGENT DORA
                        </GradientText>
                    </div>
                    <AnimatedContent
                        distance={150}
                        direction="vertical"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <BlurText
                            text="WHY AGENT DORA Why Agent DORA is Special and Unique to #GRIFFAIN  platform?"
                            delay={150}
                            animateBy="words"
                            direction="top"
                            className="md:text-4xl text-2xl font-medium !text-start !items-start !justify-start"
                        />
                    </AnimatedContent>
                </div>

                <div className='container mx-auto mt-[10vw]'>
                    <Swiper
                        navigation={true}
                        slidesPerView={1}
                        spaceBetween={10}
                        pagination={{
                            clickable: true,
                        }}
                        breakpoints={{
                            480: {
                                slidesPerView: 1,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 40,
                            },
                            1024: {
                                slidesPerView: 2,
                                spaceBetween: 50,
                            },
                        }}
                        modules={[Navigation]}
                        className='mySwiper !relative'
                    >
                        {DATA.map((item, index) => (
                            <SwiperSlide key={index}>
                                <SpotlightCard className="bg-[#1f2021] md:p-[50px] p-5  border border-[#343537] shadow-xl rounded-2xl md:rounded-3xl" spotlightColor="#61FF8630">
                                    <div className='flex flex-col items-start gap-3'>
                                        <GradientText
                                            colors={["#40ffaa", "#BEFFCD", "#7358F9",]}
                                            animationSpeed={3}
                                            showBorder={false}
                                            className="font-semibold text-lg "
                                        >
                                            {item.number}
                                        </GradientText>
                                        <SplitText
                                            text={item.heading}
                                            className="md:text-3xl text-2xl font-normal !text-start"
                                            delay={150}
                                            animationFrom={{ opacity: 0, transform: 'translate3d(0,50px,0)' }}
                                            animationTo={{ opacity: 1, transform: 'translate3d(0,0,0)' }}
                                            easing="easeOutCubic"
                                            threshold={0.2}
                                            rootMargin="-0px"
                                        />
                                        <hr className=' border-b border-[#343537] w-full mt-3' />
                                    </div>
                                    <div className='relative border border-[#343537] md:rounded-3xl rounded-2xl overflow-hidden mt-5 md:h-[25vw] h-[60vw] flex items-center justify-center p-5' >
                                        <img src={item.img} alt="" className='z-30 w-[15vw] mt-10 smooth_move_animation' />
                                        <Waves
                                            lineColor="#343537"
                                            backgroundColor="#1f2021"
                                            waveSpeedX={0.02}
                                            waveSpeedY={0.01}
                                            waveAmpX={40}
                                            waveAmpY={20}
                                            friction={0.9}
                                            tension={0.01}
                                            maxCursorMove={120}
                                            xGap={12}
                                            yGap={36}
                                        />
                                    </div>
                                </SpotlightCard>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    )
}
